/** La mail sta nello Spam: perché, e come rimetterla fra i clienti. La mail
 *  resta nella casella: OM non cancella e non sposta nulla. */
export function SpamAvviso({
  motivi,
  busy,
  onNonSpam,
}: {
  motivi: string[];
  busy: boolean;
  onNonSpam: () => void;
}) {
  return (
    <div
      role="status"
      className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-2 rounded-xl border border-line-2 bg-paper px-3 py-2 text-[12.5px] text-ink"
    >
      <p className="min-w-0 flex-1">
        <b className="font-bold">Nello spam</b>
        {motivi.length > 0 ? `: ${motivi.join(", ")}.` : "."} Nella casella la mail resta dov'è.
      </p>
      <button
        type="button"
        onClick={onNonSpam}
        disabled={busy}
        className="h-[34px] shrink-0 rounded-full border border-ink bg-card px-3.5 text-[12.5px] font-semibold text-ink transition-colors hover:bg-ink hover:text-on-ink disabled:opacity-50"
      >
        Non è spam
      </button>
    </div>
  );
}
